import Button from 'components/common/button'
import { FilterIcon } from 'components/icons'
import { useQuery } from 'hooks'
import { filterEmptyValues } from 'utils/helpers'

type Props = {
  /** URL query key that holds the filter object, e.g. `masterDataFilters`. */
  filterKey: string
}

/**
 * Shows an "N filters applied · [Clear]" chip whenever the given filter object
 * is present in the URL, so users can drop the filter from the list view
 * without reopening the filter form. Renders nothing when no filter is active.
 */
const ActiveFilterChip = ({ filterKey }: Props) => {
  const { getQuery, setMultipleQueries } = useQuery()

  const applied = filterEmptyValues(getQuery(filterKey))
  const count = Object.keys(applied).length

  if (count <= 0) return null

  const clearFilters = () => {
    // Drop the filter object and reset to page 1 in ONE navigation.
    setMultipleQueries({ [filterKey]: undefined, page: 1 })
  }

  return (
    <div className="mb-3 flex items-center gap-3 rounded-lg border border-gray-300 bg-gray-50 px-4 py-2.5">
      <span className="inline-flex h-4 w-4 shrink-0 text-gray-500">
        <FilterIcon />
      </span>
      <span className="text-sm font-semibold text-sidebar-primary">
        {count} {count === 1 ? 'filter' : 'filters'} applied
      </span>
      <Button
        type="button"
        buttonText="Clear filters"
        variant="custom"
        onClick={clearFilters}
        className="ml-auto rounded-lg px-3 py-1.5 text-sm font-semibold text-red-600 hover:bg-red-50"
      />
    </div>
  )
}

export default ActiveFilterChip
